import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { ConfirmationService } from 'primeng/api';
import { tap } from 'rxjs/operators';
import { IBeneficiarioEstudio } from 'src/app/interfaces/beneficiarios.interface';
import { GetEstudioBeneficiario, UpdateEstudioBeneficiario, UpdateEstudioBeneficiarioSuccess } from 'src/app/store/actions/beneficiarios.actions';
import { selectEstudioBeneficiario } from 'src/app/store/selectors/beneficiarios.selectors';
import { IAppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-estudio',
  templateUrl: './estudio.component.html',
  styleUrls: ['./estudio.component.scss']
})
export class EstudioComponent implements OnInit, OnDestroy {
  @Input() mode = '';
  @Input() beneficiario = '';
  @Output() closeForm = new EventEmitter<boolean>();

  formEstudio: FormGroup;
  header = 'Editar estudio socioeconomico'
  display = true;

  estudioSubscription = this.store$.pipe(
    select(selectEstudioBeneficiario),
    tap(form => {
      if (this.formEstudio) {
        this.formEstudio.patchValue({
          ...form
        });
      }
    })
  ).subscribe();

  // Opciones
  tec = [
    { label: 'Computadora de escritorio', value: 'Computadora de escritorio' },
    { label: 'Laptop', value: 'Laptop' },
    { label: 'Tablet', value: 'Tablet' }
  ];

  internet = [
    { label: 'Solo fija', value: 'Solo fija' },
    { label: 'Solo móvil', value: 'Solo móvil' },
    { label: 'Ambas', value: 'Ambas' },
    { label: 'No se', value: 'No se' }
  ];

  internet2 = [
    { label: 'Satisfecha', value: 'Satisfecha' },
    { label: 'Insatisfecha', value: 'Insatisfecha' },
    { label: 'No se', value: 'No se' }
  ];

  siNo = [
    { label: 'Si', value: 'Si' },
    { label: 'No', value: 'No' }
  ];

  niveles = [
    { label: 'Preescolar Completo', value: 'Preescolar Completo' },
    { label: 'Primaria', value: 'Primaria' },
    { label: 'Secundaria', value: 'Secundaria' },
    { label: 'Preparatoria/Bachillerato', value: 'Preparatoria/Bachillerato' },
    { label: 'Universidad Incompleta', value: 'Universidad Incompleta' },
    { label: 'Universidad Completa', value: 'Universidad Completa' }
  ];

  vivienda = [
    { label: 'Propia', value: 'Propia' },
    { label: 'Rentada', value: 'Rentada' },
    { label: 'Prestada', value: 'Prestada' },
    { label: 'Hipotecada', value: 'Hipotecada' },
    { label: 'Ninguna de las anteriores', value: 'Ninguna de las anteriores' }
  ];

  casa = [
    { label: 'A nombre de mi pareja', value: 'A nombre de mi pareja' },
    { label: 'A nombre mio', value: 'A nombre mio' },
    { label: 'A nombre de ambos', value: 'A nombre de ambos' },
    { label: 'A nombre de familiares', value: 'A nombre de familiares' },
    { label: 'De nadie', value: 'De nadie' }
  ];

  trabajos = [
    { label: 'trabajo con paga(principal)', value: 'trabajo' },
    { label: 'trabajo con paga(adicional)', value: 'trabajo' },
    { label: 'trabajo sin paga', value: 'trabajo' },
    { label: 'actualmente no trabajo', value: 'actualmente no trabajo' }
  ];

  materiales = [
    { label: 'Ladrillo', value: 'Ladrillo' },
    { label: 'Lamina', value: 'Lamina' },
    { label: 'Madera', value: 'Madera' },
    { label: 'Carton', value: 'Carton' }
  ];

  recursos = [
    { label: 'Apoyos de gobierno', value: 'Apoyo' },
    { label: 'Pensiones', value: 'Apoyo' },
    { label: 'Creditos', value: 'Apoyo' },
    { label: 'Ninguno', value: 'Ninguno' }
  ];

  apoyos = [
    { label: 'Apoyos en efectivo', value: 'Apoyos en efectivo' },
    { label: 'Apoyos en especie', value: 'Apoyos en especie' },
    { label: 'Ambos', value: 'Ambos' }
  ];

  salud = [
    { label: 'IMSS', value: 'IMSS' },
    { label: 'ISSSTE', value: 'ISSSTE' },
    { label: 'INSABI', value: 'INSABI' },
    { label: 'CRUZ ROJA', value: 'CRUZ ROJA' },
    { label: 'NINGUNO', value: 'NINGUNO' },
    { label: 'OTRO', value: 'OTRO' }
  ];

  afirmaciones = [
    { label: 'Totalmente en desacuerdo', value: 'Totalmente en desacuerdo' },
    { label: 'En desacuerdo', value: 'En desacuerdo' },
    { label: 'Ni en desacuerdo', value: 'Ni en desacuerdo' },
    { label: 'Ni de acuerdo', value: 'Ni de acuerdo' },
    { label: 'De acuerdo', value: 'De acuerdo' },
    { label: 'Totamente de acuerdo', value: 'Totamente de acuerdo' }
  ];

  afirmaciones2 = [
    { label: 'Muy poco', value: 'Muy poco' },
    { label: 'Poco', value: 'Poco' },
    { label: 'Algo', value: 'Algo' },
    { label: 'Mucho', value: 'Mucho' },
    { label: 'Totalmente', value: 'Totalmente' }
  ];

  // Seleccion Multiple
  categories: any[] = [
    { name: 'Cuento con un producto o servicio que ya vendo', key: '1' },
    { name: 'Tengo una idea de lo deseo hacer y estoy en proceso de definir el producto o servicio', key: '2' },
    { name: 'No tengo claridad de cual podría ser mi emprendimiento pero tengo motivación', key: '3' }
  ];

  casas: any[] = [
    { name: 'Luz (energia electrica)', key: '1' },
    { name: 'Agua Potable', key: '2' },
    { name: 'Drenaje', key: '3' },
    { name: 'Gas', key: '4' },
    { name: 'Regadera', key: '5' },
    { name: 'Estufa', key: '6' }
  ];

  herramientas: any[] = [
    { name: 'Radio Comunitaria', key: '1' },
    { name: 'Radio', key: '2' },
    { name: 'Television', key: '3' },
    { name: 'Celular', key: '4' },
    { name: 'Computadora', key: '5' },
    { name: 'Internet', key: '6' }
  ];

  actividades: any[] = [
    { name: 'Voto en las elecciones para cargos públicos', key: '1' },
    { name: 'Asisto a asambleas o reuniones vecinales', key: '2' },
    { name: 'Participo en actividades religiosas de mi comunidad', key: '3' },
    { name: 'Trabajo comunitario', key: '4' },
    { name: 'Voluntariado', key: '5' }
  ];

  internet3: any[] = [
    { name: 'permite descargar archivos o datos de manera rápida y sin dificultades', key: '1' },
    { name: 'permite subir o cargar archivos de manera rápida y sin dificultades', key: '2' },
    { name: 'permite reproducir videos con buena calidad y sin interrupciones.', key: '3' },
    { name: 'nunca o casi nunca se interrumpe o falla', key: '4' },
    { name: 'en general, es de buena calidad', key: '5' },
    { name: 'La calidad es baja y genera problemas contínuamente', key: '6' }
  ];

  tec2: any[] = [
    { name: 'el hogar', key: '1' },
    { name: 'el trabajo', key: '2' },
    { name: 'la escuela o institución educativa', key: '3' },
    { name: 'un sitio público con costo', key: '4' },
    { name: 'un sitio público sin costo', key: '5' },
    { name: 'casa de otra persona (amigo o familiar)', key: '6' },
    { name: 'cualquier otro lugar con una portátil', key: '7' }
  ];

  tec3: any[] = [
    { name: 'enviar y recibir correo electrónico', key: '1' },
    { name: 'descargar contenidos de Internet (música, videos, documentos, etcétera)', key: '2' },
    { name: 'copiar archivos entre directorios (carpetas)', key: '3' },
    { name: 'crear archivos de texto', key: '4' },
    { name: 'crear hojas de cálculo', key: '5' },
    { name: 'crear presentaciones', key: '6' },
    { name: 'instalar dispositivos periféricos (impresora, proyector, etcétera)', key: '7' },
    { name: 'crear o usar bases de datos', key: '8' },
    { name: 'programar en lenguaje especializado', key: '9' },
  ];

  technologies: any[] = [
    { name: 'tarda mucho tiempo en iniciar para poder ser utilizada', key: '1' },
    { name: 'necesita reiniciarse muy seguido porque se traba o se queda congelada la pantalla', key: '2' },
    { name: 'permite abrir y utilizar programas o apps de manera rápida y sin dificultades', key: '3' },
    { name: 'permite instalar nuevos programas o apps sin dificultades', key: '4' },
    { name: 'ya no permite actualizar a la última versión del sistema operativo (android, iOS, windows, OS, etc.)', key: '5' },
    { name: 'necesita que se estén eliminando archivos o desinstalando programas porque tiene poca memoria o capacidad de almacenamiento', key: '6' },
    { name: 'tiene entradas funcionando para conectar otros dispositivos (como memorias USB, impresoras, monitores o pantallas adicionales, etc.)', key: '7' },
    { name: 'la laptop o tablet necesita estar conectada a la electricidad o recargarse muy seguido para funcionar.', key: '8' },
    { name: 'en el último año, ha tenido que ser reparada más de una vez para poder funcionar', key: '9' },
    { name: 'hace mucho ruido cuando está encendida', key: '10' }
  ];

  formSubmitSubscription = this.actions$.pipe(
    ofType(UpdateEstudioBeneficiarioSuccess),
    tap(_ => {
      this.closeForm.emit(true);
    })
  ).subscribe();

  constructor(
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private store$: Store<IAppState>,
    private actions$: Actions
  ) {
    this.formEstudio = this.formBuilder.group({
      1: new FormControl(''),
      2: new FormControl(''),
      3: new FormControl(''),
      4: new FormControl(''),
      5: new FormControl(''),
      6: new FormControl(''),
      7: new FormControl(''),
      8: new FormControl(''),
      9: new FormControl(''),
      10: new FormControl(''),
      11: new FormControl(''),
      12: new FormControl(''),
      13: new FormControl(''),
      14: new FormControl(''),
      15: new FormControl(''),
      16: new FormControl(''),
      17: new FormControl(''),
      18: new FormControl(''),
      19: new FormControl(''),
      20: new FormControl(''),
      21: new FormControl(''),
      22: new FormControl(''),
      23: new FormControl(''),
      24: new FormControl(''),
      25: new FormControl(''),
      26: new FormControl(''),
      27: new FormControl(''),
      28: new FormControl(''),
      29: new FormControl(''),
      30: new FormControl(''),
      31: new FormControl(''),
      32: new FormControl(''),
      33: new FormControl(''),
      34: new FormControl(''),
      35: new FormControl(''),
      36: new FormControl(''),
      37: new FormControl(''),
      38: new FormControl(''),
      39: new FormControl(''),
      40: new FormControl(''),
      41: new FormControl(''),
      42: new FormControl(''),
      43: new FormControl(''),
      44: new FormControl(''),
      45: new FormControl(''),
      46: new FormControl(''),
      47: new FormControl(''),
      48: new FormControl(''),
      49: new FormControl(''),
      50: new FormControl(''),
      51: new FormControl(''),
      52: new FormControl(''),
      53: new FormControl(''),
      54: new FormControl(''),
      55: new FormControl(''),
      56: new FormControl(''),
      57: new FormControl(''),
      58: new FormControl(''),
      59: new FormControl(''),
      60: new FormControl(''),
      61: new FormControl(''),
      62: new FormControl(''),
      63: new FormControl(''),
      64: new FormControl(''),
      65: new FormControl(''),
      66: new FormControl(''),
      67: new FormControl(''),
      68: new FormControl(''),
      69: new FormControl(''),
      70: new FormControl(''),
      71: new FormControl(''),
      72: new FormControl(''),
      73: new FormControl(''),
      74: new FormControl(''),
      75: new FormControl(''),
      76: new FormControl(''),
      77: new FormControl(''),
      78: new FormControl(''),
      79: new FormControl(''),
      80: new FormControl(''),
      81: new FormControl(''),
      82: new FormControl(''),
      83: new FormControl(''),
      84: new FormControl(''),
      85: new FormControl(''),
      86: new FormControl(''),
      87: new FormControl(''),
      88: new FormControl(''),
      89: new FormControl(''),
      90: new FormControl(''),
      91: new FormControl(''),
      92: new FormControl(''),
      93: new FormControl(''),
      94: new FormControl(''),
      95: new FormControl(''),
      96: new FormControl(''),
      97: new FormControl(''),
      98: new FormControl(''),
      99: new FormControl(''),
      100: new FormControl(''),
      101: new FormControl(''),
      102: new FormControl(''),
      103: new FormControl(''),
      104: new FormControl(''),
      105: new FormControl(''),
      106: new FormControl(''),
      107: new FormControl(''),
      108: new FormControl(''),
      109: new FormControl(''),
      110: new FormControl(''),
      111: new FormControl(''),
      112: new FormControl(''),
      113: new FormControl(''),
      114: new FormControl(''),
      115: new FormControl(''),
      116: new FormControl(''),
      117: new FormControl(''),
      118: new FormControl(''),
      119: new FormControl(''),
      120: new FormControl(''),
      121: new FormControl(''),
      122: new FormControl(''),
      123: new FormControl(''),
      124: new FormControl(''),
      125: new FormControl(''),
      126: new FormControl(''),
      127: new FormControl(''),
      128: new FormControl(''),
      129: new FormControl(''),
      130: new FormControl(''),
      131: new FormControl(''),
      132: new FormControl(''),
      133: new FormControl(''),
      134: new FormControl(''),
      135: new FormControl(''),
      136: new FormControl(''),
      137: new FormControl(''),
      138: new FormControl(''),
      139: new FormControl(''),
      140: new FormControl(''),
      141: new FormControl(''),
      142: new FormControl(''),
      143: new FormControl(''),
      144: new FormControl(''),
      145: new FormControl(''),
      146: new FormControl(''),
      147: new FormControl(''),
      148: new FormControl(''),
      149: new FormControl(''),
      150: new FormControl(''),
    });

  }

  ngOnInit(): void {
    if (this.mode === 'DETALLE') {
      this.formEstudio.disable();
      this.header = 'Ver estudio socioeconomico';
    }

    this.store$.dispatch(GetEstudioBeneficiario({id: this.beneficiario}));
  }

  ngOnDestroy(): void {
    this.estudioSubscription.unsubscribe();
  }

  submitForm(): void {
    const form = this.formEstudio.getRawValue();
    const payload: IBeneficiarioEstudio = {
      estudio: {
        ...form
      }
    }

    this.store$.dispatch(UpdateEstudioBeneficiario({id: this.beneficiario, estudio: payload}))
    return;
  }

  hideForm(): void {
    if (this.mode === 'DETALLE') {
      this.closeForm.emit(true);
    } else {
      const form = this.formEstudio.getRawValue();
      const payload: IBeneficiarioEstudio = {
        estudio: {
          ...form
        }
      }

      this.store$.dispatch(UpdateEstudioBeneficiario({id: this.beneficiario, estudio: payload}))
    }
  }
}
